import type { CustomPropertyDef } from '../types/layer.js';

/** Default object name parameter key for new layers. */
export const DEFAULT_FEATURE_NAME_PROPERTY = 'Название';

/** Default layer parameter for object display names (created with the first feature). */
export const DEFAULT_FEATURE_NAME_CUSTOM_PROPERTY: CustomPropertyDef = {
  name: DEFAULT_FEATURE_NAME_PROPERTY,
  type: 'title',
};

/**
 * Resolves which property key stores the display name for a layer.
 * Prefers an explicit title-type parameter; falls back to 'Название' then legacy 'name'.
 */
export function resolveFeatureNameKey(
  customProperties: Array<{ name: string; type?: string }> | undefined,
): string {
  return (
    (customProperties ?? []).find((p) => p.type === 'title')?.name ??
    DEFAULT_FEATURE_NAME_PROPERTY
  );
}

/**
 * Reads the display name from feature properties, checking 'Название', legacy 'name',
 * and other common import keys.
 */
export function readFeatureDisplayName(
  properties: Record<string, unknown>,
): string | undefined {
  const candidates = [
    properties[DEFAULT_FEATURE_NAME_PROPERTY],
    properties.name,
    properties.title,
    properties.label,
    properties.Name,
    properties.TITLE,
  ];
  for (const value of candidates) {
    if (typeof value === 'string' && value.trim().length > 0) {
      return value.trim();
    }
  }
  return undefined;
}
